import * as Dialog from '@radix-ui/react-dialog';
import React, { useEffect, useState } from 'react';
import { AbsenceDetail } from '@/components/Dashboard/AbsenceDetail';
import type { AbsenceDetailSelection } from '@/components/Dashboard/AbsencesModal';
import { useCloseOnBack } from '@/hooks/useCloseOnBack';
import { useSwipeToClose } from '@/hooks/useSwipeToClose';

interface Props {
  detail: AbsenceDetailSelection | undefined;
  onClose: () => void;
}

export const AbsenceDetailSheet: React.FC<Props> = ({ detail, onClose }) => {
  const { sheetRef, swipeProps } = useSwipeToClose(onClose);
  const [shownDetail, setShownDetail] = useState<
    AbsenceDetailSelection | undefined
  >(detail);

  useCloseOnBack(detail !== undefined, onClose);

  useEffect(() => {
    if (detail) {
      setShownDetail(detail);
    }
  }, [detail]);

  const isOpen = detail !== undefined;
  const title = shownDetail?.absence.disciplineName ?? '';

  const handleOpenChange = (isNextOpen: boolean) => {
    if (!isNextOpen) {
      onClose();
    }
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/40" />
        <Dialog.Content
          ref={sheetRef}
          aria-describedby={undefined}
          className="bg-background fixed inset-x-0 bottom-0 z-50 flex max-h-[75svh] flex-col rounded-t-3xl outline-none data-[state=closed]:animate-sheet-slide-down data-[state=open]:animate-sheet-slide-up"
        >
          <div
            {...swipeProps}
            className="flex shrink-0 cursor-grab flex-col touch-none active:cursor-grabbing"
          >
            <div className="flex justify-center pt-2 pb-1">
              <div className="h-1 w-10 rounded-full bg-drag-handle" />
            </div>
            <div className="flex items-center px-4 pt-3 pb-4">
              <Dialog.Title className="text-headline-20 truncate text-foreground">
                {title}
              </Dialog.Title>
            </div>
          </div>

          <div className="relative flex-1 overflow-y-auto overscroll-contain">
            {shownDetail && (
              <AbsenceDetail nonAttendance={shownDetail.absence} />
            )}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
